  (function () {
    if (window.__wpQuickview) return;
    window.__wpQuickview = true;

    // Quick-view "See it on your wall": relay through the real PDP so exiting the
    // visualizer returns to the PDP, not the collection grid the quick view opened over.
    // In quick view the top window is still the PLP, so navigating straight to the
    // visualizer makes browser-back land on the PLP. Going PLP -> PDP -> visualizer (the
    // PDP forwards on load, see blocks/wild-helper-cards.liquid) puts the PDP in history.
    // Only preventDefault (not stopPropagation), so wild-ga4.js still fires view_on_wall.
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('.wp-quickview__wallbtn') : null;
      if (!a) return;
      var viz = a.getAttribute('href') || '';
      var m = viz.match(/[?&]referrer=([^&]*)/);
      var pdp = m && m[1] ? decodeURIComponent(m[1]) : '';
      if (!pdp) return; // no PDP referrer encoded → let it navigate normally
      e.preventDefault();
      try { sessionStorage.setItem('wpAutoViz', viz); } catch (err) {}
      location.assign(pdp);
    });

    var root = document.querySelector('[data-wp-quickview]');
    if (!root) return;
    var sheet = root.querySelector('.wp-quickview__sheet');
    var content = root.querySelector('[data-wp-quickview-content]');
    var heading = root.querySelector('[data-wp-quickview-heading]');
    var body = root.querySelector('.wp-quickview__body');
    var wishBtn = root.querySelector('[data-wp-quickview-wish]');
    var shareBtn = root.querySelector('[data-wp-quickview-share]');
    var currentProductUrl = '';
    var currentProductTitle = '';
    var lastFocus = null;
    var reqToken = 0;
    // WP-F14: Find-similar match type (the per-surface trigger toggles live on cards/PDP).
    // Set as data-fs-match on the quickview root (was a Liquid setting when this was inline).
    var FS_MATCH = root.getAttribute('data-fs-match') || 'mix';
    // Per-market sample-price rounding (Theme settings → Samples), mirrored onto the
    // quickview root. Only the product.js fallback needs it — the normal path copies the
    // price the product page already rendered.
    var SAMPLE_ROUND = root.getAttribute('data-wp-sample-round') === 'true';

    // WP-F23: Share the current product (native share, else copy the link).
    if (shareBtn) {
      shareBtn.addEventListener('click', function () {
        var url = currentProductUrl || location.href;
        var title = currentProductTitle || document.title;
        try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('wild_share', { method: 'quickview', url: url }); } catch (e) {}
        if (navigator.share) { navigator.share({ title: title, url: url }).catch(function () {}); return; }
        if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(url).catch(function () {}); }
      });
    }

    function lockScroll(on) {
      document.documentElement.style.overflow = on ? 'hidden' : '';
      document.body.style.overflow = on ? 'hidden' : '';
    }
    function pdpUrl(url) {
      return url.replace(/([?&])view=quickview(&|$)/, '$1').replace(/[?&]$/, '');
    }
    function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
    // One place builds the sample price line, so every path prints it the way the PDP
    // does: separator, ISO code, then the amount ("· SGD 4").
    function sampleLine(amount, cur) {
      if (amount === '' || amount == null) return '';
      return ' · ' + (cur ? cur + ' ' : '') + amount;
    }
    function sizedImg(src, w) {
      if (!src) return src;
      return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
    }

    // Unique gallery images from the fetched PDP (dedupe by path).
    // `secondFirst` opens the gallery on the product's SECOND image (used by the
    // "similar" modal — you've just seen image 1 on the card you clicked, so the
    // sheet leads with a fresh view; image 1 sits right beside it).
    function galleryHtml(doc, secondFirst) {
      var seen = {}, slidesArr = [];
      [].slice.call(doc.querySelectorAll('.product-media__image, media-gallery img, .wild-pdp-gallery img')).forEach(function (img) {
        var src = img.getAttribute('src') || img.getAttribute('data-src');
        if (!src) return;
        var key = src.split('?')[0];
        if (seen[key]) return;
        seen[key] = 1;
        slidesArr.push({ src: src, srcset: img.getAttribute('srcset') || '' });
      });
      slidesArr = slidesArr.slice(0, 8);
      if (secondFirst && slidesArr.length > 1) {
        var tmp = slidesArr[0]; slidesArr[0] = slidesArr[1]; slidesArr[1] = tmp;
      }
      if (!slidesArr.length) return '';
      var html = slidesArr.map(function (s, i) {
        // WP-F36: only the active (first) slide loads eagerly + high priority; the rest lazy.
        var load = i === 0 ? ' loading="eager" fetchpriority="high"' : ' loading="lazy"';
        return '<li class="wp-quickview__slide"><img src="' + esc(s.src) + '"' +
          (s.srcset ? ' srcset="' + esc(s.srcset) + '"' : '') +
          ' width="800" height="1200" sizes="(max-width: 749px) 90vw, 520px" alt=""' + load + '></li>';
      }).join('');
      return '<ul class="wp-quickview__gallery" role="list">' + html + '</ul>';
    }

    // Loading skeleton — slow glowing gray placeholders for the gallery + cards.
    function skelCards(n) {
      var s = '';
      for (var i = 0; i < n; i++) s += '<div class="wp-quickview__skel wp-quickview__skel-card"></div>';
      return '<div class="wp-quickview__related-cards wp-quickview__related-cards--skel">' + s + '</div>';
    }
    function skeletonHtml(mode) {
      if (mode === 'similar') {
        return '<div class="wp-quickview__similar">' +
            '<div class="wp-quickview__media wp-quickview__media--wide"><div class="wp-quickview__skel wp-quickview__skel-gallery"></div></div>' +
            '<div class="wp-quickview__related">' +
              '<div class="wp-quickview__skel wp-quickview__skel-title"></div>' +
              skelCards(8) +
            '</div>' +
          '</div>';
      }
      return '<div class="wp-quickview__hero">' +
          '<div class="wp-quickview__skel wp-quickview__skel-gallery"></div>' +
          '<div class="wp-quickview__panel">' +
            '<div class="wp-quickview__skel wp-quickview__skel-line wp-quickview__skel-line--lg"></div>' +
            '<div class="wp-quickview__skel wp-quickview__skel-line"></div>' +
            '<div class="wp-quickview__skel wp-quickview__skel-btn"></div>' +
          '</div>' +
        '</div>';
    }

    // Clone a real PDP element so it renders with the actual PDP markup (the matching
    // styles are mirrored into this snippet's stylesheet, since the PDP blocks' CSS isn't
    // loaded on the collection page). Any in-page (#) anchor is neutralised so a click in
    // the modal doesn't try to jump to a section that isn't here.
    function pullPdp(doc, sel) {
      var el = doc.querySelector(sel);
      if (!el) return '';
      var c = el.cloneNode(true);
      var neutralize = function (a) {
        var href = a.getAttribute('href') || '';
        if (href.charAt(0) === '#' || href === '') { a.removeAttribute('href'); a.style.pointerEvents = 'none'; }
      };
      if (c.tagName === 'A') neutralize(c);
      [].slice.call(c.querySelectorAll('a')).forEach(neutralize);
      return c.outerHTML;
    }

    // Quick view = the PDP's upper section: the product gallery (left) + the real price and
    // rating (right), capped with the "view full details & customize" CTA (the size/price
    // customizer only runs on the full PDP, so it's deliberately a click-through here). The
    // product name is shown as the modal heading, so it isn't repeated in the panel.
    function buildQuickview(doc, url) {
      var clean = pdpUrl(url);
      var priceEl = doc.querySelector('.wild-priceline');
      var priceHtml = priceEl ? pullPdp(doc, '.wild-priceline') : '';
      if (!priceHtml) {
        var p = doc.querySelector('.price');
        if (p) priceHtml = '<div class="wild-priceline"><span class="wild-priceline__price">' + p.innerHTML + '</span></div>';
      }
      // The priceline usually already contains the rating inline — only pull a standalone
      // rating when it doesn't, to avoid showing the stars twice.
      var ratingHtml = (priceEl && priceEl.querySelector('.wild-rating')) ? '' : pullPdp(doc, '.wild-rating');
      var descEl = doc.querySelector('.product-description .rte, .product-description, .wild-rich-text .rte');
      var desc = descEl ? descEl.textContent.replace(/\s+/g, ' ').trim() : '';
      if (!desc) {
        // The product description isn't rendered in the PDP rail, so fall back to the
        // page's own description meta (Shopify fills it from the product description).
        var ogd = doc.querySelector('meta[property="og:description"], meta[name="description"]');
        desc = ogd ? (ogd.getAttribute('content') || '').replace(/\s+/g, ' ').trim() : '';
      }

      // Sample = the Sample variant carried by the triggering card. Rendering a
      // [data-rc-sample] control lets the card's existing global handler add it to
      // the cart straight from the sheet (no second integration).
      var sampleSrc = currentCard && currentCard.querySelector('[data-rc-sample]');
      var sampleId = sampleSrc ? (sampleSrc.getAttribute('data-sample-variant-id') || '') : '';

      // Clone the PDP's own USP rows (.wild-trust__strip) so the quick view uses the
      // EXACT same markup + styling as the page (its CSS is mirrored into this snippet's
      // stylesheet). Only the strip — no secure-checkout / payment row. The size
      // customizer is an app that runs only on the full PDP, so the primary CTA routes
      // there.
      var trust = pullPdp(doc, '.wild-trust__strip');

      // "See it on your wall" — clone the real visualizer URL (mockup.wildpalace.com,
      // built per product in wild-helper-cards) straight from the parsed PDP.
      var vizEl = doc.querySelector('.wild-helpers__secondary, a[href*="mockup.wildpalace"]');
      var vizUrl = vizEl ? (vizEl.getAttribute('href') || '') : '';
      // The visualizer "back" link (referrer) must return to the FULL PDP, not the
      // collection/quick-view URL the card was opened from.
      if (vizUrl) {
        // The referrer drives the visualizer's "back" link — it must return to the
        // FULL PDP the shopper is viewing in quick view: the collection-scoped
        // product URL with the ?view=quickview suffix stripped (`clean`), so they
        // land on the rich product page (not the bare /products/ path or the
        // quick-view URL the card was opened from).
        var fullPdp = clean;
        try { fullPdp = new URL(clean, location.origin).href; } catch (e) {}
        vizUrl = vizUrl.replace(/([?&]referrer=)[^&]*/, '$1' + encodeURIComponent(fullPdp));
      }

      // Sample line, mirrored from the PDP: the block's own label + price (no swatch — F22).
      var sampleLbl = ((doc.querySelector('.wp-sample__label, .wild-helpers__sample-text') || {}).textContent || 'Order a sample').trim();
      // Currency ISO code from the parsed sample block. The PDP renders code-then-amount
      // ("SGD 4"), so the sheet does too — it used to print amount-then-code here.
      var sampleCur = ((doc.querySelector('#buy_sample_currency') || {}).textContent || '').trim();
      // The price the PDP itself rendered, already carrying the per-market rounding rule
      // (blocks/wild-sample.liquid). Copying it is what keeps the sheet and the page in
      // agreement — recomputing it here is exactly how they drifted (sheet showed 3.50
      // where the page showed 4). product.js only fills in when this is absent.
      var sampleExactEl = doc.querySelector('[data-wp-sample-exact]');
      var sampleExact = sampleExactEl ? (sampleExactEl.getAttribute('data-wp-sample-exact') || '').trim() : '';
      var samplePriceTxt = sampleExact ? sampleLine(sampleExact, sampleCur) : '';

      return '<div class="wp-quickview__hero">' +
          '<div class="wp-quickview__media wp-quickview__media--wide">' + galleryStageHtml(doc, clean, false, vizUrl) + '</div>' +
          '<div class="wp-quickview__panel">' +
            ((priceHtml || ratingHtml) ? '<div class="wp-quickview__pdp-meta">' + priceHtml + ratingHtml + '</div>' : '') +
            '<div class="wp-quickview__colors" data-wp-qv-colors hidden></div>' +
            '<a class="wp-quickview__cta" href="' + esc(clean) + '"><span>See price &amp; customize</span><svg class="wp-quickview__cta-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg></a>' +
            (sampleId
              ? '<button type="button" class="wp-quickview__sample-btn" data-rc-sample data-sample-variant-id="' + esc(sampleId) + '">' +
                  '<span class="wp-quickview__sample-link"><span class="wp-quickview__sample-lbl" data-rc-label="' + esc(sampleLbl) + '">' + esc(sampleLbl) + '</span><span class="wp-quickview__sample-price" data-wp-sample-price data-cur="' + esc(sampleCur) + '">' + esc(samplePriceTxt) + '</span></span>' +
                '</button>'
              : '') +
            (desc ? '<div class="wp-quickview__desc-wrap" data-wp-desc><div class="wp-quickview__desc">' + esc(desc) + '</div><button type="button" class="wp-quickview__readmore" data-wp-readmore hidden>Read more</button></div>' : '') +
            trust +
          '</div>' +
        '</div>' +
        '<div class="wp-quickview__related wp-quickview__related--inline" data-wp-related>' +
          '<h3 class="wp-quickview__related-title">More walls to imagine</h3>' +
          skelCards(8) +
        '</div>';
    }

    // Eye glyph for the "See it on your wall" visualizer link (FL-024).
    var EYE = '<svg class="wp-quickview__viz-eye" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7Z"/><circle cx="12" cy="12" r="3"/></svg>';
    var CHEV_L = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="15 18 9 12 15 6"></polyline></svg>';
    var CHEV_R = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 18 15 12 9 6"></polyline></svg>';

    // Single-image gallery stage (slides + prev/next arrows), shared by quick view and
    // explore-similar. `withGoto` adds the bottom-centre "Go to product" button.
    function galleryStageHtml(doc, clean, withGoto, vizUrl, secondFirst) {
      return '<div class="wp-quickview__stage" data-wp-gallery>' +
          '<button type="button" class="wp-quickview__gnav wp-quickview__gnav--prev" data-wp-gprev aria-label="Previous image">' + CHEV_L + '</button>' +
          galleryHtml(doc, secondFirst) +
          '<button type="button" class="wp-quickview__gnav wp-quickview__gnav--next" data-wp-gnext aria-label="Next image">' + CHEV_R + '</button>' +
          // FL-024: "See it on your wall" floats bottom-centre over the gallery
          // (white bg, black text, eye on the left) — not a buy-panel button.
          (vizUrl ? '<a class="wp-quickview__wallbtn" href="' + esc(vizUrl) + '">' + EYE + '<span>See it on your wall</span></a>' : '') +
          (withGoto ? '<a class="wp-quickview__goto" href="' + esc(clean) + '">Go to product</a>' : '') +
        '</div>';
    }

    function buildSimilar(doc, url) {
      var clean = pdpUrl(url);
      var title = ((doc.querySelector('h1') || {}).textContent || '').trim();
      var relHeading = 'More like this';
      return '<div class="wp-quickview__similar">' +
          '<div class="wp-quickview__media wp-quickview__media--wide">' +
            galleryStageHtml(doc, clean, true) +
          '</div>' +
          '<div class="wp-quickview__related" data-wp-related>' +
            '<h3 class="wp-quickview__related-title">' + relHeading + '</h3>' +
            skelCards(8) +
          '</div>' +
        '</div>';
    }

    // Similar products as real resource-cards, merged from two sources in priority order:
    //   1. Shopify product recommendations with intent=related — the best-practice "similar"
    //      signal. Shopify's engine blends product descriptions, sales data and collection
    //      relationships, so it surfaces genuinely-similar pieces (including ones that visually
    //      match but live in a different collection), not merely same-collection items. It's
    //      capped at ~10 by Shopify, so it LEADS the grid.
    //   2. The originating collection (the card link is collection-scoped, #67) — fills the
    //      tail up to REL_MAX so the grid stays full when the recommendation set is small.
    // Both runs are deduped by product id (and the current product is always excluded). For
    // even stronger cross-collection visual matching, tune intent=related via the Shopify
    // Search & Discovery app (merchant-side) — that's where the recommendation weighting and
    // manual related-product overrides live; the theme just renders whatever it returns.
    var REL_MAX = 24;
    function loadRelated(token, doc, url) {
      var holder = content.querySelector('[data-wp-related]');
      if (!holder) return;
      // Note: the related grid ("More walls to imagine") always shows in quick view; the
      // Find-similar TRIGGER is gated separately on cards/PDP (WP-F14).
      var rec = doc.querySelector('product-recommendations');
      var curPid = (rec && rec.getAttribute('data-product-id')) || '';

      function finish(gridHtml) {
        if (token !== reqToken) return;
        var skel = holder.querySelector('.wp-quickview__related-cards--skel');
        if (skel) skel.remove();
        if (!gridHtml) { holder.insertAdjacentHTML('beforeend', '<p class="wp-quickview__related-empty">No similar pieces right now.</p>'); return; }
        holder.insertAdjacentHTML('beforeend', '<div class="wp-quickview__related-cards resource-list resource-list--grid">' + gridHtml + '</div>');
        // Show each product's SECOND image by default: copy the secondary image onto
        // the always-opaque primary image element, so the modal grid leads with the
        // room/scene shot rather than the flat mural (independent of hover/opacity).
        holder.querySelectorAll('.wp-quickview__related-cards .resource-card').forEach(function (card) {
          var sec = card.querySelector('.resource-card__image--secondary');
          var prim = card.querySelector('.resource-card__image:not(.resource-card__image--secondary)');
          if (!sec || !prim) return;
          if (sec.getAttribute('src')) prim.setAttribute('src', sec.getAttribute('src'));
          if (sec.getAttribute('srcset')) prim.setAttribute('srcset', sec.getAttribute('srcset'));
          prim.setAttribute('loading', 'eager');
          sec.remove();
        });
      }

      // Pull resource-cards (with their product id) out of any parsed product surface.
      function collectCards(d) {
        var items = [].slice.call(d.querySelectorAll('.product-grid__item, .resource-list__item'));
        var cards = [];
        items.forEach(function (it) {
          var card = it.querySelector('.resource-card');
          if (!card) return;
          var pid = it.getAttribute('data-product-id') || '';
          if (!pid) {
            var holder2 = card.querySelector('[data-product-id]');
            pid = (holder2 && holder2.getAttribute('data-product-id')) || '';
          }
          cards.push({ pid: pid, html: card.outerHTML });
        });
        return cards;
      }

      function fetchRelatedRecs() {
        var base = rec && rec.getAttribute('data-url');
        var sid = rec && rec.getAttribute('data-section-id');
        if (!base || !sid || !curPid) return Promise.resolve([]);
        var u = base + '&section_id=' + encodeURIComponent(sid) + '&product_id=' + encodeURIComponent(curPid) + '&intent=related';
        return fetch(u, { headers: { 'Accept': 'text/html' } })
          .then(function (r) { return r.text(); })
          .then(function (html) { return collectCards(new DOMParser().parseFromString(html, 'text/html')); })
          .catch(function () { return []; });
      }

      function fetchCollection() {
        var m = (url || '').match(/\/collections\/([^/?#]+)\/products\//);
        if (!m) return Promise.resolve([]);
        return fetch('/collections/' + m[1], { headers: { 'Accept': 'text/html' } })
          .then(function (r) { return r.text(); })
          .then(function (html) { return collectCards(new DOMParser().parseFromString(html, 'text/html')); })
          .catch(function () { return []; });
      }

      Promise.all([fetchRelatedRecs(), fetchCollection()]).then(function (res) {
        if (token !== reqToken) return;
        var seen = {};
        if (curPid) seen[curPid] = 1;
        var out = '', n = 0;
        function add(list) {
          for (var i = 0; i < list.length && n < REL_MAX; i++) {
            var c = list[i];
            if (c.pid && seen[c.pid]) continue;
            if (c.pid) seen[c.pid] = 1;
            out += '<div class="resource-list__item">' + c.html + '</div>';
            n++;
          }
        }
        // WP-F14: the match type orders the sources. 'collection' leads with same-collection
        // items; 'mix'/'color' lead with Shopify's related engine. (Deeper colour matching is
        // a documented tuning follow-up — the feature ships hidden pending review.)
        if (FS_MATCH === 'collection') { add(res[1]); add(res[0]); }
        else { add(res[0]); add(res[1]); }
        finish(out);
      });
    }

    var currentCard = null;
    var currentMode = ''; // FL-018: the mode of the open modal, so related cards stay in-mode

    function syncWishVisual() {
      if (!wishBtn) return;
      var on = currentCard && currentCard.querySelector('[data-rc-wishlist].is-wishlisted, .resource-card__action--wishlist.is-wishlisted');
      wishBtn.classList.toggle('is-wishlisted', !!on);
      wishBtn.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
    }

    // Colors (colorways): group same-design siblings by the product's SKU prefix
    // from the shared map, mirroring the PDP. Sibling swatches link to their own
    // PDP; the current colorway is highlighted in place. Hidden if no siblings.
    function fillColors(handle) {
      // Look the product up in the shared map by handle to get its SKU prefix —
      // independent of the product.js fetch, so the Colors row always appears.
      if (!window.WPColorwayMap || !handle) return;
      window.WPColorwayMap.get().then(function (list) {
        var me = null, i;
        for (i = 0; i < (list || []).length; i++) { if (list[i].h === handle) { me = list[i]; break; } }
        if (!me) return;
        var prefix = window.WPColorwayMap.prefixOf(me.s || '');
        if (!prefix) return;
        var current = handle;
        window.WPColorwayMap.family(prefix).then(function (fam) {
        if (!fam || fam.filter(function (it) { return it.h !== current; }).length < 1) return;
        var html = '<p class="wp-quickview__colors-label">Colors <span class="wp-quickview__colors-count">(' + fam.length + ')</span></p><div class="wp-quickview__colors-row">';
        fam.forEach(function (it) {
          var pic = it.i ? '<img src="' + esc(it.i) + '" alt="" width="34" height="34" loading="lazy">' : '';
          if (it.h === current) html += '<span class="wp-quickview__color is-active" title="' + esc(it.t || '') + '">' + pic + '</span>';
          else html += '<a class="wp-quickview__color" href="' + esc(it.u) + '" title="' + esc(it.t || '') + '">' + pic + '</a>';
        });
        html += '</div>';
        // The panel can still be settling / re-rendering just after product.js
        // resolves (same reason the sample price retries), so poll for the host
        // and fill once it's there.
        var tries = 0;
        (function apply() {
          var host = content.querySelector('[data-wp-qv-colors]');
          if (!host) { if (tries++ < 15) setTimeout(apply, 120); return; }
          if (host.getAttribute('data-cw-filled')) return; // idempotent
          host.setAttribute('data-cw-filled', '1');
          host.innerHTML = html;
          // Changing colorway stays in the quick view — reopen the modal for the
          // clicked colorway instead of navigating to its PDP.
          host.querySelectorAll('a.wp-quickview__color').forEach(function (a) {
            a.addEventListener('click', function (e) {
              e.preventDefault();
              open(a.getAttribute('href'), '', currentMode || 'quickview', currentCard, '');
            });
          });
          host.removeAttribute('hidden');
        })();
        });
      });
    }

    // Description "Read more": reveal the toggle only when the clamped text overflows.
    // Idempotent — it's run again after the full description is filled in (FL-025), so it
    // re-measures overflow and never double-binds the toggle.
    function setupReadMore() {
      var wrap = content.querySelector('[data-wp-desc]');
      if (!wrap) return;
      var p = wrap.querySelector('.wp-quickview__desc');
      var btn = wrap.querySelector('[data-wp-readmore]');
      if (!p || !btn) return;
      requestAnimationFrame(function () {
        var overflowing = p.scrollHeight - p.clientHeight > 2;
        btn.hidden = !overflowing;
        if (overflowing && !btn.dataset.bound) {
          btn.dataset.bound = '1';
          btn.addEventListener('click', function () {
            var on = wrap.classList.toggle('is-expanded');
            btn.textContent = on ? 'Read less' : 'Read more';
          });
        }
      });
    }

    // FL-025: the PDP rail doesn't expose the product description as scrapeable markup
    // (the product-description block renders through the generic `text` snippet, so the
    // `.product-description` selector matches nothing and we previously fell back to the
    // truncated og:description meta — which cuts off mid-word). product.js always carries
    // the COMPLETE description, so use it as the authoritative source and replace/insert
    // the modal copy once it resolves.
    function fillDescription(html) {
      if (!html) return;
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var full = (tmp.textContent || '').replace(/\s+/g, ' ').trim();
      if (!full) return;
      var wrap = content.querySelector('[data-wp-desc]');
      if (wrap) {
        var p = wrap.querySelector('.wp-quickview__desc');
        // Only upgrade when product.js gives us more than the scraped/meta text had.
        if (p && full.length > p.textContent.trim().length) p.textContent = full;
      } else {
        // Nothing was scraped — insert the description above the primary CTA.
        var cta = content.querySelector('.wp-quickview__cta');
        if (cta) {
          cta.insertAdjacentHTML('beforebegin',
            '<div class="wp-quickview__desc-wrap" data-wp-desc><div class="wp-quickview__desc">' +
            esc(full) +
            '</div><button type="button" class="wp-quickview__readmore" data-wp-readmore hidden>Read more</button></div>');
        }
      }
      setupReadMore();
    }

    function open(url, pid, mode, card, ptype) {
      if (!url) return;
      lastFocus = document.activeElement;
      currentCard = card || null;
      currentMode = mode;
      var token = ++reqToken;
      currentProductUrl = new URL(pdpUrl(url), location.origin).href;
      var cardTitleEl = currentCard && currentCard.querySelector('.resource-card__title');
      currentProductTitle = cardTitleEl ? cardTitleEl.textContent.trim() : '';
      // Quick view shows the product name as the modal heading; explore-similar reads
      // "Similar to <product>".
      heading.textContent = mode === 'similar'
        ? (currentProductTitle ? 'Similar to ' + currentProductTitle : 'Similar products')
        : (currentProductTitle || 'Quick view');
      // Heart forwards to the triggering card's WishlistHero control (shown whenever that card
      // carries one). Share (next to the close button) shares / copies the product URL.
      if (wishBtn) {
        wishBtn.hidden = !(currentCard && currentCard.querySelector('[data-rc-wishlist]'));
        syncWishVisual();
      }
      if (shareBtn) shareBtn.hidden = !currentProductUrl;
      // Quick view uses a wider sheet (full PDP hero); explore-similar stays narrower.
      root.classList.toggle('wp-quickview--wide', mode !== 'similar');
      content.innerHTML = skeletonHtml(mode);
      root.hidden = false;
      // Force a reflow, then add is-open synchronously so the slide-up transition runs
      // even when rAF is throttled (background tab) — rAF alone could leave it off-screen.
      void root.offsetHeight;
      root.classList.add('is-open');
      lockScroll(true);
      if (body) body.scrollTop = 0;
      var closeBtn = root.querySelector('.wp-quickview__close');
      if (closeBtn) closeBtn.focus();

      // Fetch the full PDP (not ?view=quickview) so the <product-recommendations>
      // element is present for the "more like this" resource-cards.
      fetch(new URL(pdpUrl(url), location.origin).href, { headers: { 'Accept': 'text/html' } })
        .then(function (r) { return r.text(); })
        .then(function (txt) {
          if (token !== reqToken) return;
          var doc = new DOMParser().parseFromString(txt, 'text/html');
          content.innerHTML = mode === 'similar' ? buildSimilar(doc, url) : buildQuickview(doc, url);
          if (mode !== 'similar') fillColors((url.match(/\/products\/([^/?#]+)/) || [])[1]);
          // Use the PDP's own H1 as the authoritative product name in the heading.
          var h1t = (doc.querySelector('h1') || {}).textContent;
          h1t = h1t ? h1t.trim() : '';
          if (h1t) heading.textContent = (mode === 'similar') ? ('Similar to ' + h1t) : h1t;
          root.classList.remove('is-loading');
          content.querySelectorAll('.wp-quickview__gallery').forEach(setupDragScroll);
          setupGalleryDots();
          setupReadMore();
          // One product.js fetch powers both the Sample price (whole number, like the PDP)
          // and the authoritative full description (FL-025). product.js is same-origin and
          // cached, so this is cheap even when there's no sample variant.
          fetch(pdpUrl(url) + '.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (pj) {
              if (token !== reqToken) return;
              // Match the Sample variant on any option position (not just option1).
              var sampleVar = (pj.variants || []).filter(function (v) {
                return (v.options || []).indexOf('Sample') > -1 || /(^|\s)sample(\s|$)/i.test(v.title || '');
              })[0];
              // Fallback only: the price the product page rendered is copied in
              // buildQuickview and wins (the fill below is guarded on the span still being
              // empty). This runs when that page carried no sample block, or when the
              // triggering card had no sample control at all and the whole "Order a
              // sample" button has to be injected after the primary CTA. Retried on the
              // next frames because the panel can still be settling. Applies the SAME
              // per-market rounding rule as the PDP so the fallback can't reintroduce the
              // drift it used to cause.
              var renderSample = function () {
                if (mode === 'similar' || !sampleVar) return true;
                var d = sampleVar.price / 100;
                var spEl = content.querySelector('[data-wp-sample-price]');
                // Currency ISO code: prefer the code stamped at build time, else read it
                // off the priceline (which prints amount-then-code).
                var cur = (spEl && spEl.getAttribute('data-cur')) || '';
                if (!cur) {
                  var plEl = content.querySelector('.price--sqm, .wild-priceline, .price');
                  if (plEl) { var mm = (plEl.textContent || '').match(/\d[\d.,]*\s*([A-Za-z]{2,4})\b/); if (mm) cur = mm[1]; }
                }
                var amt = SAMPLE_ROUND ? Math.ceil(d) : (d % 1 === 0 ? d : d.toFixed(2));
                var priceTxt = sampleLine(amt, cur);
                if (spEl) {
                  if (!spEl.textContent.trim()) spEl.textContent = priceTxt;
                  var host = spEl.closest('[data-rc-sample]');
                  if (host && !host.getAttribute('data-sample-variant-id')) host.setAttribute('data-sample-variant-id', sampleVar.id);
                  return true;
                }
                // No sample button was rendered (the card had no sample control) —
                // inject it from product.js so the sample cost is never missing.
                var cta = content.querySelector('.wp-quickview__cta');
                if (!cta) return false;
                cta.insertAdjacentHTML('afterend',
                  '<button type="button" class="wp-quickview__sample-btn" data-rc-sample data-sample-variant-id="' + sampleVar.id + '">' +
                    '<span class="wp-quickview__sample-link"><span class="wp-quickview__sample-lbl" data-rc-label="Order a sample">Order a sample</span>' +
                    '<span class="wp-quickview__sample-price" data-wp-sample-price>' + priceTxt + '</span></span>' +
                  '</button>');
                return true;
              };
              if (!renderSample()) {
                requestAnimationFrame(renderSample);
                setTimeout(renderSample, 300);
              } else {
                setTimeout(renderSample, 300);
              }
              if (mode !== 'similar') fillDescription(pj.description);
            }).catch(function () {});
          loadRelated(token, doc, url);
        })
        .catch(function () {
          if (token !== reqToken) return;
          window.location.href = pdpUrl(url);
        });
    }

    function close() {
      root.classList.remove('is-open');
      lockScroll(false);
      var done = function () {
        root.hidden = true;
        root.classList.remove('is-loading');
        content.innerHTML = '';
        sheet.removeEventListener('transitionend', done);
      };
      sheet.addEventListener('transitionend', done);
      setTimeout(done, 380);
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }

    function galleryStep(dir) {
      var gal = content.querySelector('[data-wp-gallery] .wp-quickview__gallery');
      if (!gal) return;
      gal.scrollBy({ left: dir * gal.clientWidth, behavior: 'smooth' });
    }

    // Cursor/touch drag-to-scroll for the gallery carousels. Uses Pointer Events with
    // pointer capture so a mouse "swipe" works the same as the PDP gallery does (the
    // previous mouse-only handlers didn't track reliably inside the modal). Native touch
    // swipe is left to the browser.
    function setupDragScroll(el) {
      if (!el || el.dataset.dragBound) return;
      // Both mobile and desktop render the gallery as a horizontal single-image
      // carousel, so cursor drag-to-scroll is enabled at every width (mouse swipe,
      // like the full PDP). Native touch swipe is left to the browser on touch.
      el.dataset.dragBound = '1';
      el.style.cursor = 'grab';
      var down = false, moved = false, startX = 0, startScroll = 0, pid = null;

      el.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return; // native touch scrolling handles swipe
        down = true; moved = false; startX = e.clientX; startScroll = el.scrollLeft; pid = e.pointerId;
      });
      el.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (!moved && Math.abs(dx) > 6) {
          moved = true;
          el.classList.add('is-grabbing'); // disable snap -> smooth free-drag
          try { el.setPointerCapture(pid); } catch (err) {}
        }
        if (moved) { e.preventDefault(); el.scrollLeft = startScroll - dx; }
      });
      var end = function () {
        if (!down) return;
        down = false;
        if (moved) {
          // Settle on a slide. Two things mattered here:
          //  1. Rounding to the NEAREST slide meant a drag had to cross HALF a
          //     slide (~400px on a wide gallery) to advance, so ordinary drags felt
          //     dead. Instead any intentional drag past a small threshold advances
          //     at least one slide in the drag direction (larger drags advance
          //     proportionally).
          //  2. The drag delta + the final scroll position MUST be read BEFORE the
          //     is-grabbing class is removed: removing it re-enables
          //     `scroll-snap-type: x mandatory`, which synchronously yanks
          //     scrollLeft to the nearest snap (the start) — so reading after it
          //     always saw 0 and snapped back. We compute the target, set it while
          //     snap is still disabled, THEN re-enable snap (already on a slide, so
          //     no yank).
          var w = el.clientWidth;
          if (w > 0) {
            var dragged = el.scrollLeft - startScroll;
            var startIdx = Math.round(startScroll / w);
            var threshold = Math.min(w * 0.15, 60);
            var idx = startIdx;
            if (Math.abs(dragged) >= threshold) {
              idx = startIdx + Math.round(dragged / w);
              if (idx === startIdx) idx += dragged > 0 ? 1 : -1;
            }
            var maxIdx = Math.max(0, Math.round((el.scrollWidth - w) / w));
            idx = Math.max(0, Math.min(maxIdx, idx));
            el.scrollLeft = idx * w;
          }
          el.classList.remove('is-grabbing');
          var suppress = function (ev) { ev.stopPropagation(); ev.preventDefault(); el.removeEventListener('click', suppress, true); };
          el.addEventListener('click', suppress, true);
        } else {
          el.classList.remove('is-grabbing');
        }
      };
      el.addEventListener('pointerup', end);
      el.addEventListener('pointercancel', end);
      el.addEventListener('dragstart', function (e) { e.preventDefault(); });
    }

    // Mobile gallery dots (the gallery has no arrows on mobile — dots show it's swipeable).
    function setupGalleryDots() {
      var media = content.querySelector('.wp-quickview__media--wide');
      var gal = media && media.querySelector('.wp-quickview__gallery');
      if (!media || !gal) return;
      var slides = gal.querySelectorAll('.wp-quickview__slide');
      if (slides.length < 2) return;
      var dots = document.createElement('div');
      dots.className = 'wp-quickview__dots';
      for (var i = 0; i < slides.length; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'wp-quickview__dot' + (i === 0 ? ' is-active' : '');
        b.setAttribute('aria-label', 'Go to image ' + (i + 1));
        b.setAttribute('data-idx', i);
        dots.appendChild(b);
      }
      media.appendChild(dots);
      var update = function () {
        var idx = Math.round(gal.scrollLeft / gal.clientWidth);
        var ds = dots.querySelectorAll('.wp-quickview__dot');
        for (var j = 0; j < ds.length; j++) ds[j].classList.toggle('is-active', j === idx);
      };
      gal.addEventListener('scroll', update, { passive: true });
      dots.addEventListener('click', function (e) {
        var d = e.target.closest('.wp-quickview__dot');
        if (!d) return;
        gal.scrollTo({ left: (+d.getAttribute('data-idx')) * gal.clientWidth, behavior: 'smooth' });
      });
    }

    function forwardWishlist() {
      if (!currentCard || !wishBtn) return;
      var wrap = currentCard.querySelector('[data-rc-wishlist]');
      var ctrl = wrap && wrap.querySelector('.wishlisthero-floating, .wishlist-hero-custom-button');
      var target = ctrl && ctrl.querySelector('button, a, [role="button"]');
      // Match the product-card heart: show a loading spinner on click, then reflect the
      // real state (filled primary-colour heart once the add completes). WishlistHero
      // gives no completion event, so settle on a short poll like the card sync does.
      wishBtn.classList.add('is-loading');
      if (target) target.click(); else if (ctrl) ctrl.click();
      var settle = function () {
        wishBtn.classList.remove('is-loading');
        syncWishVisual();
      };
      setTimeout(settle, 500);
      setTimeout(settle, 1300);
    }


    document.addEventListener('click', function (e) {
      // Clicking a card in the modal's related grid swaps the modal IN PLACE to that
      // product, staying in the CURRENT mode (FL-018): in "similar" it reloads the
      // similar view for the clicked product; in "quick view" it reloads quick view.
      var relCard = e.target.closest && e.target.closest('.wp-quickview__related-cards .resource-card');
      if (relCard) {
        e.preventDefault();
        var rt = relCard.querySelector('[data-rc-quickview]');
        if (rt) {
          open(rt.getAttribute('data-quickview-url'), rt.getAttribute('data-product-id'), currentMode || 'quickview', relCard, rt.getAttribute('data-product-type') || '');
          if (body) body.scrollTop = 0;
        }
        return;
      }
      var trigger = e.target.closest && e.target.closest('[data-rc-quickview]');
      if (trigger) {
        e.preventDefault();
        var url = trigger.getAttribute('data-quickview-url');
        var pid = trigger.getAttribute('data-product-id');
        var mode = trigger.hasAttribute('data-rc-related') ? 'similar' : 'quickview';
        var ptype = trigger.getAttribute('data-product-type') || '';
        var card = trigger.closest('.resource-card');
        document.querySelectorAll('[data-rc-menu]:not([hidden])').forEach(function (m) { m.hidden = true; });
        open(url, pid, mode, card, ptype);
        return;
      }
      if (e.target.closest && e.target.closest('[data-wp-quickview-wish]')) { e.preventDefault(); forwardWishlist(); return; }
      if (e.target.closest && e.target.closest('[data-wp-gprev]')) { e.preventDefault(); galleryStep(-1); return; }
      if (e.target.closest && e.target.closest('[data-wp-gnext]')) { e.preventDefault(); galleryStep(1); return; }
      if (e.target.closest && e.target.closest('[data-wp-quickview-dismiss]')) {
        e.preventDefault();
        close();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !root.hidden) close();
    });
  })();
